/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class PromotionDetailsEditor extends Common.GridEditorBase<PromotionDetailsRow> {
        protected getColumnsKey() { return "OMS.PromotionDetails"; }
        protected getDialogType() { return PromotionDetailsDialog; }
        protected getLocalTextPrefix() { return PromotionDetailsRow.localTextPrefix; }
        protected form: PromotionDetailsForm;

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        } 
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        

        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        //protected getButtons(): Serenity.ToolButton[] {
        //    var buttons = super.getButtons();
        //    buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

        //    return buttons;
        //}
        validateEntity(row: PromotionDetailsRow, id) {
            //row.ProductID = Q.toId(row.ProductID);

            //var sameProduct = Q.tryFirst(this.view.getItems(), x => x.ProductID === row.ProductID);
            //if (sameProduct && this.id(sameProduct) !== id) {
            //    Q.alert('This product is already in order details!');
            //    return false;
            //}
          
            
            //row.PromoName = PromotionMasterRow.getLookup().itemById[row.PromoId].PromoName;
            row.CompanyName = CompanyRow.getLookup().itemById[row.CompanyId].CompanyName;
            row.ProductTypeName = FixedCodeRow.getLookup().itemById[row.ProductTypeId].FixedName;
           
           
            return true;
            //row.LineTotal = (row.Quantity || 0) * (row.UnitPrice || 0) - (row.Discount || 0);
            return true;
        }

    }
}